import 'sticky-sidebar-v2/dist/jquery.sticky-sidebar.js';

window.addEventListener('resize', ()=>{
	if(window.innerWidth >= 1200) {
		$('.sidebar').stickySidebar({});
	}

})



// WEBPACK FOOTER //
// ./scripts/sticky.js